import { UnusedSkipTokenOptions, useQuery } from '@tanstack/react-query'
import {
	WithdrawTransactionResponse,
	GetWithdrawalTransactionsParams,
} from '@/modules/transaction/types'
import { queryWithdrawTransactionOptions } from './options'

export default function useQueryWithdrawTransaction(
	payload: GetWithdrawalTransactionsParams,
	options?: UnusedSkipTokenOptions<WithdrawTransactionResponse>,
) {
	return useQuery(queryWithdrawTransactionOptions(payload, options))
}
